import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getContainerBoxProps, getHeaderContainerProps, getCloseButtonProps } from './SheetHeader.mappers.js';

var _excluded = ["title", "titleId", "subtitle", "subtitleId", "horizontalContentAlignment", "divider", "closeButton"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSheetHeader = function useSheetHeader(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    subtitle = _ref.subtitle,
    subtitleId = _ref.subtitleId,
    horizontalContentAlignment = _ref.horizontalContentAlignment,
    divider = _ref.divider,
    closeButton = _ref.closeButton,
    rest = _objectWithoutProperties(_ref, _excluded);
  var headerContentProps = {
    title: title,
    titleId: titleId,
    subtitle: subtitle,
    subtitleId: subtitleId,
    horizontalContentAlignment: horizontalContentAlignment
  };
  var containerBoxProps = _objectSpread(_objectSpread({}, rest), getContainerBoxProps());
  var headerContainerProps = getHeaderContainerProps();
  var closeButtonProps = _objectSpread(_objectSpread({}, closeButton), getCloseButtonProps());
  return {
    divider: divider,
    containerBoxProps: containerBoxProps,
    headerContainerProps: headerContainerProps,
    headerContentProps: headerContentProps,
    closeButtonProps: closeButtonProps
  };
};

export { useSheetHeader };
//# sourceMappingURL=useSheetHeader.js.map
